export var interimPalette = {
    "input": {
        "border": {
            "default": "#1C1719",
            "hovered": "#1C1719",
            "error": "#d44026",
            "readonly": "#CCCCCC",
            "active": "#cccccc",
            "disabled": "#F4F4F5",
            "success": {
                "strong": "#2e8502",
                "weak": "#2e8502"
            },
            "checked": "#1C1719"
        },
        "surface": {
            "default": "#ffffff",
            "hovered": "#ffffff",
            "active": "#ffffff",
            "readonly": "#f4f4f5",
            "disabled": "#f4f4f5",
            "success": {
                "strong": "#2e8502",
                "weak": "#eff7eb"
            },
            "checked": {
                "default": "#1C1719",
                "readonly": "#1C1719"
            }
        }
    },
    "text": {
        "placeholder": "#9a9397",
        "default": "#575355",
        "readonly": "#9a9397",
        "success": {
            "strong": "#2e8502",
            "weak": "#2e8502"
        },
        "error": "#d44026",
        "onDark": "#ffffff",
        "disabled": "#9a9397",
        "hovered": "#575355",
        "warning": "#c75300",
        "info": "#2077b6",
        "heading": "#1c1719",
        "label": "#1c1719"
    },
    "icon": {
        "default": "#575355",
        "active": "#1C1719",
        "disabled": "#9a9397",
        "error": {
            "strong": "#d44026"
        },
        "success": {
            "strong": "#2e8502"
        },
        "onDark": "#ffffff",
        "warning": {
            "strong": "#c75300"
        },
        "info": {
            "strong": "#2077b6"
        }
    },
    "dropdown": {
        "surface": {
            "default": "#ffffff",
            "hovered": "#f4f4f5",
            "active": "#CAF0C9"
        },
        "border": {
            "default": "#cccccc"
        }
    },
    "utility": {
        "divider": "#cccccc",
        "brand": "#89dd5f",
        "focus": "#2077b6",
        "link": "#1c1719",
        "success": {
            "strong": "#2e8502",
            "weak": "#eff7eb"
        },
        "error": {
            "strong": "#d44026",
            "weak": "#fff1ed"
        },
        "warning": {
            "strong": "#c75300",
            "weak": "#fff6de"
        },
        "info": {
            "strong": "#2077b6",
            "weak": "#f0f5f7"
        },
        "neutral": {
            "strong": "#797577",
            "weak": "#e6e6e6"
        },
        "surface": "#ffffff",
        "overlay": "#111827"
    },
    "tooltip": {
        "surface": "#797577"
    },
    "dialog": {
        "surface": "#ffffff",
        "border": "#cccccc"
    },
    "buttons": {
        "primary": {
            "surface": {
                "default": "#1c1719",
                "hovered": "#1c1719cc",
                "disabled": "#F4F4F5",
                "loading": "#F4F4F5"
            },
            "contents": {
                "default": "#ffffff",
                "disabled": "#9A9397",
                "loading": "#575355"
            }
        },
        "secondary": {
            "surface": {
                "default": "#ffffff",
                "hovered": "#f4f4f5",
                "disabled": "#ffffff",
                "loading": "#ffffff"
            },
            "contents": {
                "default": "#1c1719",
                "disabled": "#9A9397",
                "loading": "#575355"
            },
            "border": {
                "default": "#1c1719",
                "hovered": "#1c1719",
                "disabled": "#f4f4f5",
                "loading": "#f4f4f5"
            }
        },
        "tertiary": {
            "border": {
                "hovered": "#cccccc"
            },
            "surface": {
                "hovered": "#ffffff"
            },
            "contents": {
                "default": "#1c1719",
                "disabled": "#9A9397",
                "loading": "#575355",
                "hovered": "#1c1719"
            }
        },
        "tertiaryNeutral": {
            "border": {
                "hovered": "#cccccc"
            },
            "surface": {
                "hovered": "#ffffff"
            },
            "contents": {
                "default": "#1c1719",
                "disabled": "#1c1719",
                "loading": "#1c1719",
                "hovered": "#1c1719"
            }
        },
        "tertiaryOnDark": {
            "border": {
                "hovered": "#cccccc"
            },
            "surface": {
                "hovered": "#ffffff"
            },
            "contents": {
                "default": "#1c1719",
                "disabled": "#1c1719",
                "loading": "#1c1719",
                "hovered": "#1c1719"
            }
        },
        "critical": {
            "primary": {
                "surface": {
                    "default": "#D44026",
                    "hovered": "#D44026CC"
                },
                "contents": {
                    "default": "#ffffff",
                    "disabled": "#ffffff"
                }
            },
            "secondary": {
                "surface": {
                    "default": "#ffffff",
                    "hovered": "#FFF1ED"
                },
                "contents": {
                    "default": "#d44026",
                    "disabled": "#d44026"
                },
                "border": {
                    "default": "#d44026",
                    "disabled": "#fff1ed"
                }
            },
            "tertiary": {
                "contents": {
                    "default": "#fff1ed",
                    "disabled": "#fff1ed",
                    "hovered": "#fff1ed"
                }
            }
        }
    },
    "stepItem": {
        "indicator": {
            "active": "#2077b6",
            "disabled": "#f0f5f7",
            "complete": "#cccccc",
            "hovered": "#f0f5f7"
        },
        "text": {
            "default": "#9a9397",
            "disabled": "#9a9397",
            "hovered": "#161517",
            "active": "#161517"
        }
    },
    "card": {
        "surface": {
            "default": "#ffffff",
            "hovered": "#f4f4f5"
        },
        "border": {
            "default": "#cccccc",
            "hovered": "#cccccc"
        }
    },
    "navItem": {
        "default": "#1c1719",
        "hovered": "#1c1719",
        "selected": "#1c1719",
        "contents": "#ffffff",
        "notification": "#fff6de"
    },
    "navPopover": {
        "surface": "#1c1719",
        "border": "#cccccc"
    },
    "dataViz": {
        "stem": "#ffffff",
        "pinBorder": "#cccccc",
        "pinFill": "#f0f5f7",
        "axisLines": "#cccccc"
    },
    "listItems": {
        "surface": {
            "default": "#ffffff",
            "hovered": "#f4f4f5",
        },
        "border": {
            "default": "#cccccc",
            "hovered": "#cccccc"
        }
    },
    "layout": {
        "containerSurface": "#ffffff",
        "pageSurface": "#ffffff"
    },
    "popover": {
        "surface": {
            "default": "#ffffff",
            "hovered": "#f4f4f5",
            "active": "#ffffff"
        },
        "border": {
            "default": "#cccccc"
        }
    },
    "sheet": {
        "surface": "#ffffff",
        "border": "#cccccc"
    },
    "modal": {
        "surface": "#ffffff",
        "border": "#cccccc"
    },
    "status": {
        "success": {
            "strong": "#2e8502",
            "weak": "#eff7eb"
        },
        "error": {
            "strong": "#d44026",
            "weak": "#fff1ed"
        },
        "warning": {
            "strong": "#c75300",
            "weak": "#fff6de"
        },
        "info": {
            "strong": "#2077b6",
            "weak": "#f0f5f7"
        }
    },
    "table": {
        "border": {
            "default": "#cccccc",
            "weak": "#f4f4f5",
            "strong": "#1c1719",
            "hovered": "#cccccc",
            "selected": "#2E8502"
        },
        "background": {
            "default": "#ffffff",
            "header": "#F4F4F5",
            "selected": "#CAF0C9",
            "hovered": "#F4F4F5"
        }
    }
};
//# sourceMappingURL=interim-palette.js.map